module.exports = __webpack_public_path__ + "static/access_map_ortho_ja-ace99d9a4665bc07b4f00d71629ecafd.svg";